let currentLogicalPage: string | null = null;
const restoredPages: Record<string, boolean> = {};

export function getLogicalPage(pathname: string): string {
  if (pathname.includes("/pending")) return "pending";
  if (pathname.includes("/assigned")) return "assigned";
  if (pathname.includes("/completed")) return "completed";
  if (pathname.includes("/invoices")) return "invoices";
  if (pathname.includes("/dashboard")) return "dashboard";
  if (pathname === "/" || pathname === "/projects") return "projects";
  const match = pathname.match(/^\/([^/]+)/);
  return match ? match[1] : pathname;
}

export function recordNavigation(pathname: string): void {
  const logical = getLogicalPage(pathname);
  if (logical !== currentLogicalPage) {
    currentLogicalPage = logical;
    delete restoredPages[logical];
  }
}

/**
 * Determines whether saved view settings should be restored for pageName.
 * Returns true only on initial entry to pageName from a different page or fresh page load.
 * Returns false when navigating or changing projects within the same pageName.
 */
export function shouldRestorePage(pathname: string, pageName: string): boolean {
  const logical = getLogicalPage(pathname);
  if (logical !== pageName) {
    return false;
  }
  if (logical !== currentLogicalPage) {
    currentLogicalPage = logical;
    delete restoredPages[logical];
  }
  if (!restoredPages[pageName]) {
    restoredPages[pageName] = true;
    return true;
  }
  return false;
}
